import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import UpdateLoanLendingProduct from "Communication/ApiClasses/UpdateLoanLendingProductRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";
import {
  LOAN_UPDATE_SECURITY,
  LOAN_UPDATE_SECURITY_ERROR,
} from "../../../Redux/Actions/actionTypes";

// worker
function* handleUpdateLoanSecurity(action) {
  yield put(
    doLoadingStart(STRINGS.LOAN_DETAILS.API_KEYS.LOAN_UPDATE_LOAN_SECURITY)
  );
  const updateLoanLendingProduct = new UpdateLoanLendingProduct(
    action.data.applicationId,
    action.data.lendingProductId,
    action.data.payLoad
  );
  try {
    const result = yield call(updateLoanLendingProduct.getData);
    yield put({
      type: actionTypes.LOAN_UPDATE_SECURITY_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_UPDATE_SECURITY_ERROR,
      error: e.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.LOAN_DETAILS.API_KEYS.LOAN_UPDATE_LOAN_SECURITY)
    );
  }
}

// watcher
function* updateLoanSecurityWatcherSaga() {
  yield takeLatest(actionTypes.LOAN_UPDATE_SECURITY, handleUpdateLoanSecurity);
}

export default updateLoanSecurityWatcherSaga;
